import React from 'react';
import LessonStructure from './lesson-structure';

export interface IInlineComponents {
  htmlFileString: string;
}

function InlineComponents({ htmlFileString }: IInlineComponents) {
  const formattedFileString = htmlFileString
    .replaceAll(/<a/g, '<a target="_blank"')
    .replaceAll(/<Link/g, '<a ')
    .replaceAll(/\bCitação\b/g, '')
    .replaceAll(/\bReferência\b/g, '')
    .replaceAll('<p>&lt;Imagem&gt;</p>', '')
    .replaceAll('<p>&lt;secaoProximaAula&gt;</p>', '')
    .replaceAll('<p><br/>', '<p>')
    .replaceAll(/ﬂ/g, 'fl');

  const parser = new DOMParser();
  const doc = parser.parseFromString(formattedFileString, 'text/html');
  return (
    <LessonStructure doc={doc} />
  );
}

export default InlineComponents;
